import requests from "./httpService";

const BillingServices = {
  createBilling(billingData) {
    return requests.post("/api/billing", billingData);
  },

  getAllBillings(storeId) {
    return requests.get(`/api/billing?storeId=${storeId}`);
  },

  getBillingById(id) {
    return requests.get(`/api/billing/${id}`);
  },

  updateBilling(id, billingData) {
    return requests.put(`/api/billing/${id}`, billingData);
  },

  deleteBilling(id) {
    return requests.delete(`/api/billing/${id}`);
  },
  generateInvoice(id) {
    return requests.get(`/api/billing/${id}/invoice`, { responseType: "blob" });
  },
};
export default BillingServices;
